import { Component, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';
import { RequestWithdrawalModal } from '../request-withdrawal-modal/request-withdrawal-modal.component';
import { ConfirmModal } from '@app/shared/modals';
import { AppFilter } from '@app/shared/models';

interface IDeactivateWalletModalContext {
  balances: any;
}
@Component({
  selector: 'app-deactivate-wallet-modal',
  templateUrl: './deactivate-wallet-modal.component.html',
  styleUrls: ['./deactivate-wallet-modal.component.scss'],
})
export class DeactivateWalletModalComponent implements OnInit {
  success: any;
  error: any;
  allZero = false;
  pending = false;
  currencyId!: string;
  filter = new AppFilter({
    sidx: 'walletCreatedDate',
    sord: 'desc',
    _search: false,
  });
  constructor(
    public modal: SuiModal<IDeactivateWalletModalContext, void, void>,
    private walletService: EwalletService,
    private modalService: SuiModalService
  ) {
    console.log(this.modal.context.balances, 'balances');
  }
  checkIfActive() {
    for (const balance of this.modal.context.balances) {
      if (balance.balance <= 0 && balance.bookBalance <= 0) {
        this.allZero = false;
        return;
      }
      if (balance.status == 'ACTIVE' && !this.currencyId) {
        this.currencyId = balance.currencyId;
      }
    }
    this.allZero = true;
    return this.allZero;
  }
  ngOnInit(): void {
    for (const balance of this.modal.context.balances) {
      if (balance.balance > 0 && balance.bookBalance > 0) {
        this.allZero = false;
        return;
      }
      if (balance.status == 'ACTIVE' && !this.currencyId) {
        this.currencyId = balance.currencyId;
      }
    }
    this.allZero = true;
  }
  getBalances(params: any) {
    this.pending = true;
    // Get Balances
    const user = JSON.parse(localStorage.getItem('user'));
    const nccId = user.organizationId.jpaContractor.nccId;
    this.walletService
      .getBalances({
        params: {
          ...params,
          nccId: nccId,
        },
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.modal.context.balances = res['rows'];
        },
        (err) => {
          this.error = err.error;
          this.pending = false;
        }
      );
  }
  deactivateWallet() {
    if (!this.checkIfActive()) {
      this.modalService
        .open(
          new ConfirmModal(
            'Deactivate Account',
            'Are you sure you want to deactive this account?',
            ModalSize.Tiny
          )
        )
        .onApprove(() => {
          this.pending = true;
          const user = JSON.parse(localStorage.getItem('user'));
          console.log(this.modal.context.balances);
          const payload = {
            nccId: this.modal.context.balances[0].nccId,
            currencyId: this.currencyId,
            createdBy: {
              appUserId: user.appUserId,
              username: user.username,
              name: user.firstName,
            },
            accountDetails: {
              bankAccountName: this.modal.context.balances[0].activeBankDetails
                ? this.modal.context.balances[0].activeBankDetails
                    ?.bankAccountName
                : this.modal.context.balances[1].activeBankDetails
                    ?.bankAccountName,
              bankAccountNumber: this.modal.context.balances[0]
                .activeBankDetails
                ? this.modal.context.balances[0].activeBankDetails
                    ?.bankAccountNumber
                : this.modal.context.balances[1].activeBankDetails
                    ?.bankAccountNumber,
              bankId: this.modal.context.balances[0].activeBankDetails
                ? this.modal.context.balances[0].activeBankDetails?.bankId
                : this.modal.context.balances[1].activeBankDetails?.bankId,
              bankName: this.modal.context.balances[0].activeBankDetails
                ? this.modal.context.balances[0].activeBankDetails?.bankName
                : this.modal.context.balances[1].activeBankDetails?.bankName,
            },
          };
          this.walletService.deactivateAccount({ body: payload }).subscribe(
            (results) => {
              this.pending = false;
              this.modal.approve(undefined);
            },
            (error) => {
              this.error = error.error.errorMessage
                ? error.error.errorMessage
                : error.error.error
                ? error.error.error
                : error.error
                ? error.error
                : error;
              console.log(error, this.error, 'ereror');
              this.pending = false;
            }
          );
        });
    } else {
      this.error =
        'To deactivate all eWallet accounts, your eWallet balance and book balance must be zero. You need to withdraw all funds to deactivate your eWallet account.';
    }
  }
  closeAccount(account) {
    this.modalService
      .open(new RequestWithdrawalModal(account, true))
      .onApprove(() => {
        this.modalService
          .open(
            new ConfirmModal(
              'Close Account',
              'Your request has been received and submitted successfully. Once approved, your account will be closed.',
              ModalSize.Tiny,
              'Okay',
              ''
            )
          )
          .onApprove(() => {
            this.getBalances(this.filter);
          });
      });
  }
}

export class DeactivateWalletModal extends ComponentModalConfig<
  IDeactivateWalletModalContext,
  void,
  void
> {
  constructor(balances: any, size: ModalSize = ModalSize.Tiny) {
    super(DeactivateWalletModalComponent, {
      balances,
    });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
